import React from "react";
import "./Loader.css";

function Loader() {
  return (
    <div
      style={{
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translateX(-50%) translateY(-50%)",
        // transform: "translateY(-50%)",
      }}
    >
      <div class="loader"></div>
    </div>
  );
}

export default Loader;
